import { Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CaseShareForm } from "src/forms/CaseShareForm";

import type { CaseBase } from "src/types";

export function CaseShareDialog(props: { open: boolean; case: CaseBase; onClose: () => void }) {
  const { t } = useTranslation();

  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth>
      <DialogTitle component={Typography} variant="h3">
        {t("label.shareCase")}: {props.case.name}
      </DialogTitle>
      <DialogContent>
        <CaseShareForm caseId={props.case.id} onClose={props.onClose} />
      </DialogContent>
    </Dialog>
  );
}
